// extracted by mini-css-extract-plugin
module.exports = {"Grid":"QuickStats_Grid__c3QMY","StatBox":"QuickStats_StatBox__2FMzC","Value":"QuickStats_Value__17qEa","Label":"QuickStats_Label__1s1ta","Streak":"QuickStats_Streak__TuoNk"};